module.exports = __webpack_public_path__ + "7e4233e2a4cbcc83cd1de59d53900423.png";